import { loadableWithFallback } from '@vision/ui/utils';
import type { FunnelChart1Props } from './FunnelChart1';

export const FunnelChart1 = loadableWithFallback<FunnelChart1Props>(() => import('./FunnelChart1'));
